// src/components/RadarChartComponent.js

import React from 'react';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
} from 'chart.js';
import { Radar } from 'react-chartjs-2';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const tipoColores = {
  Gobierno: '#1e4b81',
  Gestion: '#d37d36',
  Calidad: '#555555'
};

const escalaPorRole = {
  ROLE_FREEMIUM: { max: 1, stepSize: 1 },
  ROLE_PREMIUM: { max: 2, stepSize: 1 },
  ROLE_PREMIUMPRO: { max: 5, stepSize: 1 }
};

// ✅ PASO 1: ACEPTA EL NUEVO PROP 'labelFontSize'
export default function RadarChartComponent({ tipoKey, procesos, resultados, userRole, labelFontSize = 14 }) { // Por defecto será 12
  const color = tipoColores[tipoKey];
  const labels = procesos; 
  const escala = escalaPorRole[userRole] || { max: 3, stepSize: 1 };

  const data = labels.map(abbr => {
    const match = resultados.find(r => r.abreviatura === abbr && r.tipo === tipoKey);
    return match ? match.nivelCapacidad : 0;
  });

  const pointColors = labels.map(abbr => {
    const match = resultados.find(r => r.abreviatura === abbr && r.tipo === tipoKey);
    return match ? color : '#ccc';
  });

  const pointRadius = labels.map(abbr => {
    const match = resultados.find(r => r.abreviatura === abbr && r.tipo === tipoKey);
    return match ? 5 : 0;
  });

  const chartData = {
    labels,
    datasets: [{
      label: 'Nivel de Capacidad',
      data,
      backgroundColor: 'rgba(0,0,0,0)',
      borderColor: color,
      borderWidth: 2,
      pointBackgroundColor: pointColors,
      pointBorderColor: pointColors,
      pointRadius
    }]
  };

  const options = {
    scales: {
      r: {
        min: 0,
        max: escala.max,
        ticks: { stepSize: escala.stepSize },
        pointLabels: {
          color: pointColors,
          // ✅ PASO 2: AÑADE LA PROPIEDAD 'size' AL OBJETO font
          font: { 
            weight: 'bold',
            size: labelFontSize, // Usamos el prop aquí
          }
        }
      }
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          title: function (tooltipItems) {
            const tooltipValue = tooltipItems[0].raw;

            if (tooltipValue !== 0) {
              const abbreviation = tooltipItems[0].label;
              const match = resultados.find(
                r => r.abreviatura === abbreviation && r.tipo === tipoKey
              );
              return match ? match.nombre : abbreviation;
            }

            const matchingProcesses = resultados
              .filter(r =>
                procesos.includes(r.abreviatura) &&
                r.tipo === tipoKey &&
                r.nivelCapacidad === 0
              )
              .map(r => `• ${r.nombre}`); 

            return `Procesos con nivel 0:\n${matchingProcesses.join('\n')}`;
          },
          label: function (tooltipItem) {
            const tooltipValue = tooltipItem.raw;
            const index = tooltipItem.dataIndex;

            const processesWithZero = resultados.filter(
              r => procesos.includes(r.abreviatura) && r.tipo === tipoKey && r.nivelCapacidad === 0
            );

            const count = processesWithZero.length;

            if (tooltipValue === 0 && count > 1) {
              const firstIndex = labels.findIndex(abbr =>
                resultados.find(r =>
                  r.abreviatura === abbr &&
                  r.tipo === tipoKey &&
                  r.nivelCapacidad === 0
                )
              );

              if (index === firstIndex) {
                return 'Nivel de Capacidad: 0';
              } else {
                return ''; 
              }
            }
            
            return `${tooltipItem.dataset.label}: ${tooltipValue}`;
          }
        }
      }
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return <Radar data={chartData} options={options} />;
}